import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Nav } from "@/components/mta/Nav";
import { Hero } from "@/components/mta/Hero";
import { Marquee } from "@/components/mta/Marquee";
import { Philosophy } from "@/components/mta/Philosophy";
import { Worlds } from "@/components/mta/Worlds";
import { SmallScale } from "@/components/mta/SmallScale";
import { Wow } from "@/components/mta/Wow";
import { Architects } from "@/components/mta/Architects";
import { Brands } from "@/components/mta/Brands";
import { Interactive } from "@/components/mta/Interactive";
import { Process } from "@/components/mta/Process";
import { Portfolio } from "@/components/mta/Portfolio";
import { Technology } from "@/components/mta/Technology";
import { Scale } from "@/components/mta/Scale";
import { Configurator } from "@/components/mta/Configurator";
import { CtaSection } from "@/components/mta/CtaSection";
import { Contact } from "@/components/mta/Contact";
import { Finale } from "@/components/mta/Finale";
import { scrollToId, ThemeContext } from "@/components/mta/shared";

function App() {
    const [visionPrefill, setVisionPrefill] = useState("");
    const [theme, setTheme] = useState(() => {
        try { return localStorage.getItem("mta-theme") || "night"; } catch { return "night"; }
    });

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.3, smoothWheel: true });
        let raf;
        const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
        raf = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(raf); lenis.destroy(); };
    }, []);

    useEffect(() => {
        document.documentElement.dataset.theme = theme;
        try { localStorage.setItem("mta-theme", theme); } catch {}
    }, [theme]);

    const toggleTheme = useCallback(() => {
        const root = document.documentElement;
        root.classList.add("theme-anim");
        setTheme((t) => (t === "night" ? "day" : "night"));
        setTimeout(() => root.classList.remove("theme-anim"), 1100);
    }, []);

    const handleCreate = useCallback((vision) => {
        setVisionPrefill(vision);
        scrollToId("contact");
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            <div className="App" data-testid="app-root">
                <div className="noise-overlay" aria-hidden="true" />
                <Nav />
                <main>
                    <Hero />
                    <Marquee />
                    <Philosophy />
                    <Worlds />
                    <SmallScale />
                    <Wow />
                    <Architects />
                    <Brands />
                    <Interactive />
                    <Process />
                    <Portfolio />
                    <Technology />
                    <Scale />
                    <Configurator onCreate={handleCreate} />
                    <CtaSection />
                    <Contact visionPrefill={visionPrefill} />
                    <Finale />
                </main>
                <Toaster position="bottom-right" theme={theme === "day" ? "light" : "dark"} />
            </div>
        </ThemeContext.Provider>
    );
}

export default App;
